import { memo } from 'react'

const SwitchCheckIcon = () => (
    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.86612 0.366117C8.35427 -0.122039 9.14573 -0.122039 9.63388 0.366117C10.122 0.854272 10.122 1.64573 9.63388 2.13388L4.63388 7.13388C4.14573 7.62204 3.35427 7.62204 2.86612 7.13388L0.366117 4.63388C-0.122039 4.14573 -0.122039 3.35427 0.366117 2.86612C0.854272 2.37796 1.64573 2.37796 2.13388 2.86612L3.75 4.48223L7.86612 0.366117Z"
            fill="black"
        />
    </svg>
)
export default memo(SwitchCheckIcon)
